import type { ICustomerPayment } from "@/data/model/CustomerPayment";
import { Signal } from "@/data/util/Signal";

import { translations } from "@/shared/localization/translations";
import { Ripple } from "@/shared/ui/Ripple";

import { BaseController } from "@/app/controller/BaseController";

export class OpenBillsController extends BaseController {
    public onGoBack?: { () };
    public onClick?: { (model: ICustomerPayment) };

    private readonly $openBillsList: JQuery;

    static onShown = new Signal();
    static onHidden = new Signal();

    constructor() {
        super("open-bills");

        const hdr = $(`<div class="head"><div class="title">${translations.openBills.title}</div></div>`).appendTo(
            this.$view
        );

        Ripple.bind($('<a class="action left" href="#"><i class="fal fa-arrow-left"></i></a>'))
            .prependTo(hdr)
            .click((e) => {
                e.preventDefault();
                if (this.onGoBack !== undefined) {
                    this.onGoBack();
                }
            });

        this.$openBillsList = $('<div class="open-bills-list scrollable" />').appendTo(this.$view);
    }

    protected onBecomeInvisible() {
        setTimeout(() => {
            OpenBillsController.onHidden.dispatch();
        }, 500);
    }

    protected onBecomeVisible() {
        OpenBillsController.onShown.dispatch();
    }
}
